import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

import { FsvMenuCard } from "../FsvMenuCard";
import { FsvSpaceCard } from "../FsvSpaceCard";

// The section labels are visually hidden but kept as headings, so screen-reader
// users can still jump to each card (FsvCard's title isn't a heading).
export const FsvCardGrid = () => {
  return (
    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-24">
      <div>
        <Text element="h5" className="tw-sr-only">
          <FormattedMessage defaultMessage="Reserved area" />
        </Text>
        <FsvSpaceCard />
      </div>
      <div>
        <Text element="h5" className="tw-sr-only">
          <FormattedMessage defaultMessage="Browse menu" />
        </Text>
        <FsvMenuCard />
      </div>
    </div>
  );
};
